import { render, staticRenderFns } from "./twoflanks_v1.0.vue?vue&type=template&id=07c64ec4&"
import script from "./twoflanks_v1.0.vue?vue&type=script&lang=js&"
export * from "./twoflanks_v1.0.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports